import { SettingsProvider } from '../../contexts';

import { DarkMode } from './DarkMode';
import { DarkModeController as DarkModeThemeController } from './DarkModeProvider_unstable';
import { ThemeMerger } from './ThemeMerger';
import { ThemeProvider } from './ThemeProvider';

import type { FC, ReactNode } from 'react';

type MuiThemeComponent = typeof Theme & {
  Provider: typeof ThemeProvider;
  DarkModeController: typeof DarkModeThemeController;
  DarkMode: typeof DarkMode;
  Settings: typeof SettingsProvider;
  Merge: typeof ThemeMerger;
};

const Theme: FC<{ children: ReactNode }> = ({ children }) => (
  <>
    {children}
  </>
);

export const MuiTheme: MuiThemeComponent = Object.assign( Theme, {
  Provider: ThemeProvider,
  DarkModeController: DarkModeThemeController,
  DarkMode,
  Settings: SettingsProvider,
  Merge: ThemeMerger,
} );
